import React from "react";
import GroupMemberRecord from "models/view-models/group-member-record";
import { t } from "utilities/localization-utils";
import DataTable from "organisms/data-tables/data-table";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface PreviewTeamMembersListProps {
    groupName: string;
    groupMembers?: GroupMemberRecord[];
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const BASE_CLASS = "c-preview-team-members-list";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const PreviewTeamMembersList: React.FC<PreviewTeamMembersListProps> = (
    props
) => {
    const { groupMembers } = props;

    return (
        <DataTable cssClassName={BASE_CLASS}>
            <thead>
                <tr>
                    <th>{t("name")}</th>
                    <th>{t("email")}</th>
                </tr>
            </thead>
            <tbody>
                {groupMembers?.map((member: GroupMemberRecord) => (
                    <tr key={member.legacyId}>
                        <td>{member.getFirstAndLastName()}</td>
                        <td>{member.email}</td>
                    </tr>
                ))}
            </tbody>
        </DataTable>
    );
};

// #endregion Component

export default PreviewTeamMembersList;
